<!-- For group nodes (folders) - show only text -->
<div *ngIf="isGroupNode()" class="folder-name d-flex align-items-center">
  <span nz-icon nzType="folder" nzTheme="outline" class="mr-2 text-muted"></span>
  <span class="text-bold">{{ getDisplayValue() }}</span>
</div>

<!-- For leaf nodes (media items) - show full functionality -->
<div *ngIf="!isGroupNode()" class="d-flex align-items-center h-100">
  <!-- Error placeholder container (non-screen thumbnails only; screen previews self-heal below) -->
  <div
    *ngIf="params?.imageContainer && params.data?.urlError && params.screenType !== 1"
    [ngClass]="getImageContainerClass()"
    nz-tooltip
    nzTooltipTitle="No preview available"
    role="img"
    aria-label="No preview available"
    (click)="onClick(getImageClickAction())"
  >
  </div>

  <!-- Regular image for non-screen type -->
  <div
    *ngIf="params.screenType !== 1 && params?.imageContainer && params.data && !params.data?.urlError"
    [ngClass]="getSuccessImageContainerClass()"
    (click)="onClick(getImageClickAction())"
  >
    <img
      *ngIf="params.data?.thumbnailUrl"
      [src]="params.data?.thumbnailUrl"
      [alt]="'Icon for ' + (getDisplayValue() || 'item')"
      (error)="onClick('ERROR')"
      nz-tooltip
    />
    <ng-container *ngIf="!params.data?.thumbnailUrl">
      <img
        class="theme-img-light"
        [src]="params.data?.iconUrl"
        [alt]="'Icon for ' + (getDisplayValue() || 'item')"
        (error)="onClick('ERROR')"
        nz-tooltip
      />
      <img
        class="theme-img-dark"
        [src]="params.data?.iconUrlDark"
        [alt]="'Icon for ' + (getDisplayValue() || 'item')"
        (error)="$any($event.target).src = params.data?.iconUrl"
        nz-tooltip
      />
    </ng-container>
  </div>

  <!-- Screen preview image: <img> stays mounted even on error so the 30s refresh can self-heal it once the player uploads -->
  <div
    *ngIf="params?.imageContainer && params.data && params.screenType === 1"
    [ngClass]="getScreenPreviewContainerClass()"
    (click)="onClick('PREVIEW')"
    nz-tooltip
    [nzTooltipTitle]="params.data?.urlError ? previewUnavailableMessage() : 'Click to preview'"
  >
    <!-- Placeholder shown while the preview is unavailable; the <img> below stays in the DOM underneath.
         Web Player screens get a persistent info icon (own tooltip repeats the reason) instead of a bare,
         unexplained placeholder — the cell is too small for the full sentence to sit inline.
         No separate box classes here: the parent (.table-image-scrn-container) already provides the
         sized/bordered box, this just centers the icon within it. -->
    <div
      *ngIf="params.data?.urlError"
      class="d-flex align-items-center justify-content-center w-100 h-100"
      role="img"
      [attr.aria-label]="previewUnavailableMessage()"
    >
      <span
        *ngIf="isWebPlayerPreview()"
        nz-icon
        nzType="info-circle"
        nzTheme="outline"
        nz-tooltip
        [nzTooltipTitle]="previewUnavailableMessage()"
      ></span>
    </div>
    <img
      [id]="'preview_' + params.data?.code"
      [src]="params.data?.previewUrl"
      [alt]="'Preview for ' + (getDisplayValue() || 'item')"
      (error)="onScreenPreviewError()"
      (load)="onScreenPreviewLoad()"
      [style.display]="params.data?.urlError ? 'none' : 'block'"
    />
  </div>

  <!-- Name/text content -->
  <div class="flex-grow-1 min-width-0 d-flex align-items-center">
    <a
      *ngIf="getDisplayValue(); else noValueTemplate"
      class="text-ul text-ellipsis d-block w-100"
      (click)="onClick('NAME')"
      nz-tooltip
      [nzTooltipTitle]="getDisplayValue()"
      role="button"
      tabindex="0"
      (keydown.enter)="onClick('NAME')"
      (keydown.space)="onClick('NAME')"
      style="line-height: 1.4; max-width: 100%;"
    >
      {{ getDisplayValue() }}
    </a>
    <div
      *ngIf="getSubtitle()"
      class="name-subtitle text-muted"
      style="white-space: normal; line-height: 1.3;"
    >
      {{ getSubtitle() }}
    </div>
    
    <ng-template #noValueTemplate>
      <span class="text-muted">-</span>
    </ng-template>
  </div>
</div>